import React from "react";
import {
  Box,
  Button,
  FormGroup,
  TextField,
  CircularProgress,
} from "@mui/material";
import { AccountCircle, Https } from "@mui/icons-material";
import { styled } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";

const GridBlockContent = styled("div")(({ theme }) => ({
  display: "grid",
  maxWidth: "100%",
  gridTemplateColumns: "auto",
  gap: "1px solid #ccc",
  fontFamily: "Poppins !important",
  fontSize: "14px",
  fontWeight: "bold",
}));

const LoginForm = ({
  loginData,
  handleChange,
  handleKeyPassword,
  onCaptchaChange,
  handleSubmit,
  loading,
}) => {
  return (
    <FormGroup>
      <GridBlockContent>
        <Box pt={2} pb={1}>
          <Box p={2} pb={2} sx={{ display: "flex", alignItems: "flex-end" }}>
            <AccountCircle sx={{ color: "action.active", mr: 1, my: 0.5 }} />
            <TextField
              id="username-input"
              label=""
              placeholder="Username"
              variant="standard"
              name="username"
              type="text"
              value={loginData.username}
              onChange={handleChange}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box p={2} pb={2} sx={{ display: "flex", alignItems: "flex-end" }}>
            <Https sx={{ color: "action.active", mr: 1, my: 0.5 }} />
            <TextField
              id="password-input"
              label=""
              placeholder="Password"
              variant="standard"
              name="password"
              type="password"
              value={loginData.password}
              onKeyDown={handleKeyPassword}
              onChange={handleChange}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box pl={6} sx={{ display: "flex", alignItems: "flex-end" }}>
            <ReCAPTCHA
              name="GRecaptchaResponse"
              sitekey="6LedjHcqAAAAADQ4cXAsHC8BXdPXHM3G_InwLbSi"
              onChange={onCaptchaChange}
            />
          </Box>
        </Box>
        <Box p={2} textAlign={"right"}>
          {loading ? (
            <Button variant="contained" color="primary">
              <CircularProgress
                style={{
                  height: "20px",
                  width: "20px",
                  color: "#fff",
                  marginRight: "10px",
                }}
              />{" "}
              Loading
            </Button>
          ) : (
            <Button color="primary" variant="contained" onClick={handleSubmit}>
              <b>Login</b>
            </Button>
          )}
        </Box>
      </GridBlockContent>
    </FormGroup>
  );
};

export default LoginForm;
